var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBeneficiarioProgramasSociais(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10C27 7 29.48 6 33 6C35.9174 6 38.7153 7.15893 40.7782 9.22183C42.8411 11.2847 44 14.0826 44 17C44 21.58 40.98 25.08 38 28L24 42L10 28C7 25.1 4 21.6 4 17C4 14.0826 5.15893 11.2847 7.22183 9.22183C9.28473 7.15893 12.0826 6 15 6C18.52 6 21 7 24 10ZM24 10L18.0802 15.92C17.6738 16.3234 17.3513 16.8032 17.1312 17.3319C16.9112 17.8605 16.7979 18.4274 16.7979 19C16.7979 19.5726 16.9112 20.1395 17.1312 20.6681C17.3513 21.1968 17.6738 21.6766 18.0802 22.08C19.7202 23.72 22.3402 23.78 24.0802 22.22L28.2202 18.42C29.2579 17.4784 30.609 16.9568 32.0102 16.9568C33.4114 16.9568 34.7625 17.4784 35.8002 18.42L41.7202 23.74M36 30L32 26M30 36L26 32",
    stroke: "#022A59",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeneficiarioProgramasSociais);
export default __webpack_public_path__ + "static/media/icon-beneficiario-programas-sociais.04b8f00a.svg";
export { ForwardRef as ReactComponent };